export const getSpecialFormLabels = (value: string, label: string) => {
  if (value === 'request_justification_explanation') {
    return 'Business Justification';
  }

  if (value === 'upload_attachment') {
    return 'Attachments';
  }

  return label;
};

export const getSpecialFormLineLimits = (name: string) => {
  if (name === 'request_justification_explanation') {
    return 3;
  }

  return 1;
};
